export function useRenderingMode() {
	const runtimeConfig = useRuntimeConfig()
	const isMobileApp = runtimeConfig.public.IS_MOBILE_APP === 'true'
	let isSSR = process.server || (process.client && useNuxtApp().payload.serverRendered)

	return {
		isSSR,
		isClient: !isSSR,
		isMobileApp,
	}
}
